import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHospitals, IProgramCaseState, TError } from './types/program-case-interface';
import { fetchProgramCase, fetchProgramDownload } from './actions/fetch-program-case';


const initialState: IProgramCaseState = {
    caseProgram: [],
    HospitalCount: 0,
    PrintName: '',
    isLoadingCaseProgram: false,
    errorCaseProgram: [],
    lastFetchTime: null,
    programID: "",
    currentPage: 1,
    isDownload: false,
    errorDownload: [],
    FileData: "",
    FileName: ""
};

export const programCase = createSlice({
    name: 'programCase',
    initialState,
    reducers: {
        resetListData: (state) => {
            state.caseProgram= [];
            state.HospitalCount = 0;
            state.PrintName = '';
            state.isLoadingCaseProgram = false;
            state.errorCaseProgram = [];
            state.lastFetchTime = null;
            state.programID = '';
            state.currentPage = 1;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        },
        setCurrentPage: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPage = action.payload.page;
        },
        resetFileData: (state) => {
            state.caseProgram = state.caseProgram;
            state.HospitalCount = state.HospitalCount;
            state.PrintName = state.PrintName;
            state.isLoadingCaseProgram = state.isLoadingCaseProgram;
            state.errorCaseProgram = state.errorCaseProgram;
            state.lastFetchTime = state.lastFetchTime;
            state.programID = state.programID;
            state.currentPage = state.currentPage;
            state.isDownload = false;
            state.errorDownload = [];
            state.FileData = "";
            state.FileName = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProgramCase.pending, (state) => {
                state.isLoadingCaseProgram = true;
            })
            .addCase(fetchProgramCase.fulfilled, (state, action: PayloadAction<{ case: IHospitals[], hospitalCount: number, printName: string, fetchTime: number, programID: string }>) => {
                state.isLoadingCaseProgram = false;
                state.caseProgram = action.payload.case;
                state.HospitalCount = action.payload.hospitalCount;
                state.PrintName = action.payload.printName;
                state.errorCaseProgram = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.programID = action.payload.programID;
                state.currentPage = state.currentPage;
            })
            .addCase(fetchProgramCase.rejected, (state, action) => {
                state.caseProgram = [];
                state.PrintName = '';
                state.isLoadingCaseProgram = false;
                state.errorCaseProgram = action.payload as TError;
                state.currentPage = 1;
            })
            .addCase(fetchProgramDownload.pending, (state) => {
                state.isDownload = true;
            })
            .addCase(fetchProgramDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownload = false;
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
                state.errorDownload = [];
            })
            .addCase(fetchProgramDownload.rejected, (state, action) => {
                state.FileData = '';
                state.FileName = '';
                state.isDownload = false;
                state.errorDownload = action.payload as TError;
            });
    },
});

export const { resetListData, setCurrentPage, resetFileData } = programCase.actions;
export default programCase.reducer;